/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  GlobalRemoteSessionIssuer,
  GlobalRemoteSessionIssuer$inboundSchema,
} from "./globalremotesessionissuer.js";

/**
 * Result type for the platform-administrator global issuer listing.
 */
export type ListGlobalRemoteSessionIssuersResult = {
  items: Array<GlobalRemoteSessionIssuer>;
  /**
   * Cursor for the next page; empty when exhausted.
   */
  nextCursor?: string | undefined;
};

/** @internal */
export const ListGlobalRemoteSessionIssuersResult$inboundSchema: z.ZodMiniType<
  ListGlobalRemoteSessionIssuersResult,
  unknown
> = z.pipe(
  z.object({
    items: z.array(GlobalRemoteSessionIssuer$inboundSchema),
    next_cursor: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "next_cursor": "nextCursor",
    });
  }),
);

export function listGlobalRemoteSessionIssuersResultFromJSON(
  jsonString: string,
): SafeParseResult<ListGlobalRemoteSessionIssuersResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      ListGlobalRemoteSessionIssuersResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListGlobalRemoteSessionIssuersResult' from JSON`,
  );
}
